module.exports = __webpack_public_path__ + "img/emoji_12.a422f021.png";